import { useCallback, useEffect, useState } from "react";

/**
 * Seconds left before an action may run again. Used to pace email resends:
 * Firebase rejects them with auth/too-many-requests when they come too fast.
 */
const useCooldown = () => {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (remaining <= 0) return undefined;
    const timer = setTimeout(() => setRemaining((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [remaining]);

  const start = useCallback((seconds) => setRemaining(seconds), []);

  return [remaining, start];
};

export default useCooldown;
